import { render, staticRenderFns } from "./KoIKOTableColumn.vue?vue&type=template&id=fa0e7a4a"
import script from "./KoIKOTableColumn.vue?vue&type=script&lang=js"
export * from "./KoIKOTableColumn.vue?vue&type=script&lang=js"
import style0 from "./KoIKOTableColumn.vue?vue&type=style&index=0&id=fa0e7a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports